import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { getBaggageItemById, putMarkDepuratedById } from '../../../../actions';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import withEndpointAuthorization from '../../authorization/withEndPointAuthorization';
import { WRITE } from '../../../../config/permissions';
import { generateMarkBaggageItemDepuratedEndpoint } from '../../../../config/endpoints';

const ItemDepuratedButton = ({
  itemId,
  dispatchPutMarkDepuratedById,
  loading,
  dispatchGetBaggageItemById,
}) => {
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleChangeToUnclaimedDepurated = async () => {
    await dispatchPutMarkDepuratedById({ id: itemId });
    dispatchGetBaggageItemById(itemId);
  };

  const onClickConfirm = async () => {
    setShowConfirmation(false);
    await handleChangeToUnclaimedDepurated();
  };

  const onClickCancel = () => setShowConfirmation(false);

  return (
    <>
      <ConfirmationModal
        show={showConfirmation}
        title="Confirmar depuración"
        body="¿Está seguro que desea depurar este equipaje? Esta acción no se puede deshacer."
        onClickConfirm={onClickConfirm}
        onClickCancel={onClickCancel}
      />
      <Button
        color="info"
        onClick={() => setShowConfirmation(true)}
        disabled={loading}
      >
        <i className="fa fa-eye" /> Depurar
      </Button>
    </>
  );
};

ItemDepuratedButton.propTypes = {
  itemId: PropTypes.string.isRequired,
  dispatchPutMarkDepuratedById: PropTypes.func.isRequired,
  dispatchGetBaggageItemById: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

ItemDepuratedButton.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ BaggageUnit }) => ({
  loading: !BaggageUnit.Item.getIn(['current', 'activity']).isEmpty(),
});

const mapDispatchToProps = {
  dispatchPutMarkDepuratedById: putMarkDepuratedById,
  dispatchGetBaggageItemById: getBaggageItemById,
};

const ItemDepuratedButtonConnected = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ItemDepuratedButton);

export default withEndpointAuthorization({
  url: generateMarkBaggageItemDepuratedEndpoint(0),
  permissionType: WRITE,
})(ItemDepuratedButtonConnected);
